// import React, { useState, useEffect, useRef } from "react";
// import SidebarItems from "./SidebarItems";
// import "../../styles/sidebar/sidebar.css";
// import { NavLink } from "react-router-dom";
// import { Icon } from "@iconify/react/dist/iconify.js";
// import Cookies from "js-cookie";
// import { useTheme } from "../../ThemeContext";

// const Sidebar = ({ role }) => {
//   const [isDropdownVisible, setIsDropdownVisible] = useState(false);
//   const userName = Cookies.get("userName");
//   const userRole = Cookies.get("role");
//   const userEmail = Cookies.get("email");
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const sidebarRef = useRef(null);
//   const menuButtonRef = useRef(null);
//   const { theme, toggleTheme } = useTheme();

//   const getInitials = (name) => {
//     if (!name || !name.length) {
//       return "";
//     }
//     const nameArray = name?.split(" ")[0];
//     return nameArray[0].toUpperCase();
//   };

//   const userInitials = getInitials(userName);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         isSidebarOpen &&
//         sidebarRef.current &&
//         !sidebarRef.current.contains(event.target) &&
//         menuButtonRef.current &&
//         !menuButtonRef.current.contains(event.target)
//       ) {
//         setIsSidebarOpen(false);
//       }
//     };
//     if (isSidebarOpen) {
//       document.addEventListener("mousedown", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [isSidebarOpen]);

//   const handleMenuClick = () => {
//     setIsSidebarOpen(!isSidebarOpen);
//   };

//   const formatRole = (role) => {
//     const roleMap = {
//       SUPER_ADMIN: "Super Admin",
//       CLIENT: "Client",
//       SCANNER_OPERATOR: "Scanner Operator",
//       DATA_ENTRY_CLERK: "Data Entry Clerk",
//       PROJECT_COORDINATOR: "Project Coordinator",
//       SCANNER_ASSISTANT: "Scanner Assistant",
//       SUPERVISOR: "Supervisor",
//     };
//     return roleMap[role] || role;
//   };
//   const filteredItems = role
//     ? SidebarItems.filter((item) => item.roles.includes(role))
//     : SidebarItems.filter((item) => item.roles.includes("user"));

//   const handleMouseEnter = () => {
//     setIsDropdownVisible(true);
//   };

//   const handleMouseLeave = () => {
//     setIsDropdownVisible(false);
//   };
//   return (
//     <>
//       <div className="sidebar-wrapper">
//         <button
//           className="menu-button"
//           onClick={handleMenuClick}
//           ref={menuButtonRef}
//         >
//           <Icon icon="material-symbols:menu-rounded" width="24" height="24" />
//         </button>
//         <div
//           ref={sidebarRef}
//           className={`sidebar-container ${isSidebarOpen ? "open" : ""}`}
//         >
//           <div className="sidebar">
//             <div className="sidebar-icons">
//               {filteredItems.map((item, index) => (
//                 <NavLink
//                   to={item.path}
//                   key={index}
//                   className={({ isActive }) =>
//                     isActive ? "sidebar-item active" : "sidebar-item"
//                   }
//                 >
//                   {item.icon}
//                 </NavLink>
//               ))}
//             </div>

//             <div
//               className="profile"
//               onMouseEnter={handleMouseEnter}
//               onMouseLeave={handleMouseLeave}
//             >
//               <div className="profile-image">
//                 <div className="initials">{userInitials}</div>
//               </div>
//               {isDropdownVisible && (
//                 <div className="profile-dropdown">
//                   <div className="profile-info">
//                     <div className="profile-name">{userName}</div>
//                     <div className="profile-email">{userEmail}</div>
//                     <div className="profile-role">{formatRole(userRole)}</div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Sidebar;


import React, { useState, useEffect, useRef } from "react";
import SidebarItems from "./SidebarItems";
import "../../styles/sidebar/sidebar.css";
import { NavLink } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import Cookies from "js-cookie";
import { useTheme } from "../../ThemeContext";

const Sidebar = ({ role }) => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const userName = Cookies.get("userName");
  const userRole = Cookies.get("role");
  const userEmail = Cookies.get("email");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const sidebarRef = useRef(null);
  const menuButtonRef = useRef(null);
  const { theme, toggleTheme } = useTheme();

  const getInitials = (name) => {
    if (!name || !name.length) {
      return "";
    }
    const nameArray = name?.split(" ")[0];
    return nameArray[0].toUpperCase();
  };

  const userInitials = getInitials(userName);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isSidebarOpen &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        menuButtonRef.current &&
        !menuButtonRef.current.contains(event.target)
      ) {
        setIsSidebarOpen(false);
      }
    };
    if (isSidebarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSidebarOpen]);

  const handleMenuClick = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const formatRole = (role) => {
    const roleMap = {
      SUPER_ADMIN: "Super Admin",
      CLIENT: "Stakeholder",
      SCANNER_OPERATOR: "Scanner Operator",
      DATA_ENTRY_CLERK: "Data Entry Clerk",
      PROJECT_COORDINATOR: "Project Coordinator",
      SCANNER_ASSISTANT: "Scanner Assistant",
      SUPERVISOR: "Supervisor",
    };
    return roleMap[role] || role;
  };
  
  const filteredItems = role
    ? SidebarItems.filter((item) => item.roles.includes(role))
    : SidebarItems.filter((item) => item.roles.includes("user"));

  const handleMouseEnter = () => {
    setIsDropdownVisible(true);
  };

  const handleMouseLeave = () => {
    setIsDropdownVisible(false);
  };

  return (
    <>
      <div className="sidebar-wrapper">
        <button
          className="menu-button"
          onClick={handleMenuClick}
          ref={menuButtonRef}
          aria-label="Toggle menu"
        >
          <Icon icon="material-symbols:menu-rounded" width="24" height="24" />
        </button>
        <div
          ref={sidebarRef}
          className={`sidebar-container ${isSidebarOpen ? "open" : ""}`}
        >
          <div className="sidebar">
            <div className="sidebar-icons">
              {filteredItems.map((item, index) => (
                <div 
                  key={index}
                  className="sidebar-item-wrapper"
                  onMouseEnter={() => setHoveredItem(index)}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <NavLink
                    to={item.path}
                    className={({ isActive }) =>
                      isActive ? "sidebar-item active" : "sidebar-item"
                    }
                    aria-label={item.title}
                  >
                    {item.icon}
                  </NavLink>
                  {hoveredItem === index && (
                    <div className="sidebar-tooltip">
                      {item.title}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div
              className="profile"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <div className="profile-image">
                <div className="initials">{userInitials}</div>
              </div>
              {isDropdownVisible && (
                <div className="profile-dropdown">
                  <div className="profile-info">
                    <div className="profile-name">{userName}</div>
                    <div className="profile-email">{userEmail}</div>
                    <div className="profile-role">{formatRole(userRole)}</div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;